const Footer = () => {
    return ( 
        <div className="footer">
            <i className='bx bxs-wallet' style={{color: '#4A5A6A'}}></i>
            <i className='bx bxs-compass'></i>
            <i className='bx bxs-bell'></i>
            <i className="material-icons">settings</i>
            <div className="bar"></div>
        </div>
     );
}
 
export default Footer;